import React from 'react';
// @ts-expect-error
import {CSSTransitionGroup} from 'react-transition-group';

import DataConnector from 'connect/DataConnector';
import OnboardingConstants from 'constants/OnboardingConstants';
import * as SpaceUtil from 'growth/SpaceUtil';
import HomeDashboardStore from 'home-dashboard/HomeDashboardStore';
import ChecklistItemListing from 'onboarding/ChecklistItemListing';
import {
  ENTRY_CHECKLIST_KEY,
  ENTRY_CHECKLIST_TITLE,
  NUEModuleEnhancedProps,
  OnboardingTask,
} from 'onboarding/OnboardingConstants';
import {makeEntryListItems, trackChecklistCollapsed} from 'onboarding/OnboardingUtils';
import EntityStore from 'stores/EntityStore';
import * as TransitionConstants from 'ui-library/TransitionConstants';

class EntryNUEModuleConnector extends DataConnector<{isSampleEntry: boolean}, NUEModuleEnhancedProps> {
  shouldSubscribeToRedux = false;
  stores = [HomeDashboardStore];

  enhanceProps(): NUEModuleEnhancedProps {
    const elnModule = this.homeDashboardStore().getNUEModuleState(OnboardingConstants.MODULES.ENTRY);
    return {
      completed: elnModule?.completed ?? false,
      tasks: elnModule?.tasks ?? null,
      collapsed: elnModule?.collapsed ?? false,
      openIndex: elnModule?.openIndex ?? null,
      visible: !elnModule?.acknowledgedCompleted && !elnModule?.dismissed,
    };
  }
}

function handleChangeCollapsed(isCollapsed: boolean): void {
  trackChecklistCollapsed(isCollapsed, ENTRY_CHECKLIST_KEY, ENTRY_CHECKLIST_TITLE);
}

function EntryNUEModule({
  tasks,
  completed,
  collapsed,
  openIndex,
  visible,
  isSampleEntry,
}: NUEModuleEnhancedProps): JSX.Element {
  const currentUser = EntityStore.currentUser();
  const canEarnSpace = currentUser && !SpaceUtil.hasUnlimitedSpace(currentUser);

  let listItems: Array<OnboardingTask> = [];
  if (visible && currentUser && tasks) {
    listItems = makeEntryListItems(tasks, isSampleEntry ?? false, completed ?? false, canEarnSpace);
  }

  return (
    <>
      {listItems.length !== 0 && (
        <CSSTransitionGroup
          transitionName="transition-slideLeft"
          transitionEnterTimeout={TransitionConstants.TRANSITION_SLIDE_LEFT_DURATION_MS}
          transitionLeaveTimeout={TransitionConstants.TRANSITION_SLIDE_LEFT_DURATION_MS}
          transitionAppear={true}
          transitionAppearTimeout={TransitionConstants.TRANSITION_APPEAR_TIMEOUT_MS}
        >
          <ChecklistItemListing
            title="Explore the Notebook"
            module={OnboardingConstants.MODULES.ENTRY}
            listItems={listItems}
            collapsed={collapsed!}
            completed={completed}
            openIndex={openIndex}
            onChangeCollapsed={handleChangeCollapsed}
            fixedSize={true}
          />
        </CSSTransitionGroup>
      )}
    </>
  );
}

export default EntryNUEModuleConnector.connect(EntryNUEModule);
